<template>
  <v-card min-width="20vw" align="center" justify="center" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_AbandonTest') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action><v-icon class="icon" @click="close" icon>fa-times</v-icon></v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <p v-html="$t('description_AbandonTest')"/>
      <v-text-field v-model="confirmText" :placeholder="$t('confirmPlaceholder')" outlined/>
      <v-btn :disabled="!passCheck" @click="abandonTest">{{ $t('btnAbandon') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../../repositories/funding';
export default {
  name: "AbandonTest",
  data() {
    return {
      passCheck: false,
      confirmText: '',
    };
  },
  watch: {
    confirmText() {
      let toCheck = (this.$i18n.locale === 'en')? 'CONFIRM' : 'CONFIRMAR';
      this.confirmText = this.confirmText.toUpperCase();
      this.passCheck = (this.confirmText === toCheck);
    },
  },
  methods: {
    abandonTest() {
      Repository.abandonFundingTest(this.$store.state.fundingTest.id).then((response) => {
        if(response.status < 400) {
         alert(this.$t('alerts.successfulAbandoned'));
         this.close();
         this.$router.push({ name: 'funding-simulation-home' });
        }
        else
          alert(this.$t('alerts.error'));
      });
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>



<style scoped>

</style>
